/**
 * Shared formatters for report payloads.
 * Growth figures are null when there is no comparable baseline, so they
 * must render as "n/a" instead of a misleading 0.00%.
 */
export const formatPercent = (
  value,
  { digits = 2, signed = false, fallback = "n/a" } = {},
) => {
  if (value === null || value === undefined || value === "") return fallback;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return fallback;
  const sign = signed && numeric > 0 ? "+" : "";
  return `${sign}${numeric.toFixed(digits)}%`;
};

export const isComparable = (value) =>
  value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));
